import React, { useState } from "react";
import { LucidePanelLeftClose, LucidePanelRightClose } from "lucide-react";

const Properties: React.FC = () => {
  const [isPropertiesOpen, setIsPropertiesOpen] = useState(true);
  return (
    <div
      className={`bg-white border-l border-gray-200 flex flex-col ${
        isPropertiesOpen ? "w-80" : "w-auto"
      }`}
    >
      <div className="p-4 border-b border-gray-200 flex items-center justify-between">
        {isPropertiesOpen && (
          <h2 className="text-lg font-semibold">Properties</h2>
        )}
        <button
          className="p-2 rounded-full hover:bg-gray-100"
          onClick={() => setIsPropertiesOpen(!isPropertiesOpen)}
        >
          {isPropertiesOpen ? (
            <LucidePanelRightClose className="w-4 h-4" />
          ) : (
            <LucidePanelLeftClose className="w-4 h-4" />
          )}
        </button>
      </div>
      {isPropertiesOpen && <div className="p-4">Properties</div>}
    </div>
  );
};

export default Properties;
